module.exports = __webpack_public_path__ + "static/media/w1.04428de6.png";